import { STANDARD_RESUME } from '@components/userDocuments/editDocument/editResume/EditSpace/EditorPane/Pad/ExpertTips/Shared/expertTipsEnums';
import { getKeyForExpertTips } from '@components/userDocuments/editDocument/editResume/EditSpace/EditorPane/Pad/utils/getKeyExpertTips';

export default (data) => {
  const { userPreferences, updateVersion, formatType } = data || {};

  const fieldOfStudy = getKeyForExpertTips(formatType) || STANDARD_RESUME;

  const updateUserPreferences = {
    ...userPreferences,
    fieldOfStudy,
    version: {
      number: updateVersion,
      updated: true,
    },
  };
  return updateUserPreferences;
};
